module.exports = {"510626100":"万安镇","510626101":"鄢家镇","510626102":"金山镇","510626103":"略坪镇","510626104":"御营镇","510626105":"慧觉镇","510626106":"调元镇","510626107":"新盛镇","510626108":"蟠龙镇","510626113":"白马关镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510626.json
// module id = 2296
// module chunks = 0